// extracted by mini-css-extract-plugin
module.exports = {"popupRow":"List_popupRow_2Vlkb","pagination":"List_pagination_3S1yv","paginationText":"List_paginationText_2fKN4","paginationButton":"List_paginationButton_3ZGj1"};